/**
 * @module classNames
 * @package @geenius/adapters/solidjs-ark
 * @description Small class-name combiner used by the Ark-native component
 * wrappers without adding another runtime dependency to the variant package.
 */

export function classNames(
  ...classes: Array<string | false | null | undefined>
): string {
  return classes.filter(Boolean).join(" ");
}
